import React from 'react';
import { PortfolioData } from '../types/portfolio';

interface CaseStudiesProps {
  data: PortfolioData;
}

const CaseStudies: React.FC<CaseStudiesProps> = ({ data }) => {
  return (
    <section className="py-24 bg-ivory">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="text-4xl font-manrope font-bold text-navy mb-4">
            Selected Work & Business Impact
          </h2>
          <p className="text-lg text-slate max-w-2xl">
            Professional responsibilities and documented outcomes from business analysis initiatives.
          </p>
          <div className="h-1 w-16 bg-teal rounded-full mt-4"></div>
        </div>

        {/* Case Studies Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {data.caseStudies.map((study, idx) => (
            <div
              key={study.id}
              className="group bg-white p-8 rounded-2xl border-2 border-gray-200 hover:border-teal transition-all duration-300 hover:shadow-xl animate-fadeInUp"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              {/* Header */}
              <div className="mb-6">
                <div className="inline-block mb-4">
                  <span className="inline-flex items-center justify-center w-10 h-10 bg-teal/10 rounded-full text-teal font-bold text-lg">
                    {idx + 1}
                  </span>
                </div>
                <h3 className="text-xl font-manrope font-bold text-navy mb-3 group-hover:text-teal transition-colors">
                  {study.title}
                </h3>
              </div>

              {/* Focus */}
              <div className="mb-6 pb-6 border-b border-gray-100">
                <p className="text-sm font-semibold text-teal uppercase tracking-widest mb-2">Focus Area</p>
                <p className="text-slate leading-relaxed">
                  {study.focus}
                </p>
              </div>

              {/* Outcome */}
              <div>
                <p className="text-sm font-semibold text-gold uppercase tracking-widest mb-2">Documented Outcome</p>
                <p className="text-slate leading-relaxed font-semibold">
                  {study.outcome}
                </p>
              </div>

              {/* Visual Accent */}
              <div className="mt-8 pt-6 border-t border-gray-100">
                <div className="h-1 w-12 bg-gradient-to-r from-teal to-gold rounded-full group-hover:w-24 transition-all duration-300"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-16 p-8 bg-white rounded-xl border border-gray-200 text-center">
          <p className="text-slate text-base leading-relaxed">
            These case studies represent summaries of professional responsibilities and contributions within my role at Kyndryl. They demonstrate practical application of business analysis methodologies, technical tools, and collaborative approaches to drive measurable business improvements.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
